import { type BillingPrice, type BillingProduct } from "src/queries/billing";

import { BillingProductPickerCard } from "./BillingProductPickerCard";

interface Props {
  products: BillingProduct[];
  interval: "MONTH" | "YEAR";
  selectedPriceId: string | null;
  currentPriceId?: string;
  onSelect: (price: BillingPrice, product: BillingProduct) => void;
}

export function BillingProductPicker(props: Props) {
  const entries = props.products.flatMap((product) => {
    const price = product.prices.find(
      (candidate) => candidate.interval === props.interval,
    );
    return price ? [{ product, price }] : [];
  });

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {entries.map((entry) => {
        return (
          <BillingProductPickerCard
            key={entry.price.id}
            product={entry.product}
            price={entry.price}
            selected={entry.price.id === props.selectedPriceId}
            isCurrent={entry.price.id === props.currentPriceId}
            onSelect={props.onSelect}
          />
        );
      })}
    </div>
  );
}
